/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDistance = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M6 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm16 16a2 2 0 1 1-4 0 2 2 0 0 1 4 0zM7 6H6v5h2V9.414l1.293 1.293 1.414-1.414L9.414 8H11V6zm3.293 5.707 2 2 1.414-1.414-2-2zM18 17v-4h-2v1.586l-1.293-1.293-1.414 1.414L14.586 16H13v2h5z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgDistance as Distance };
